import React, { Component } from 'react';
import _ from 'lodash';
import {
  Button,
  Modal,
  Label,
  UncontrolledTooltip
} from 'reactstrap';
import Service from '../services';
import Loader from '../../../../commons/loader';
import ProgressButton from '../../../../commons/ProgressButton';
import { DatePicker, PaginationTotal } from '../../../../commons/controls';
import NetworkEmptyState from '../../../../commons/networkemptystate';
import DataEmptyState from '../../../../commons/dataemptystate';
import BootstrapTable2 from 'react-bootstrap-table-next';
import filterFactory, { textFilter, selectFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import Utility from '../Utility';
import { ModalFoglalas, ModalPartner } from './Modals';
import RFField from '../../../../components/Form/RFField';
import RFForm from '../../../../components/Form/RFForm';
import Lib from '../../../../commons/lib';

class Tablazat extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dolgozoFilterSelected: null,
      dolgozoOptions: [],
      email: false,
      foglalasSelected: [],
      insert: true,
      modalFoglalas: false,
      modalFoglalasDelete: false,
      modalFoglalasListConfirm: false,
      modalFoglalasListDelete: false,
      modalPartner: false,
      obj: {},
      orszagOptions: [],
      partnercsoportOptions: [],
      partnerobj: {},
      szolgaltatasok: [],
      szolgaltatasOptions: [],
      teremOptions: [],
      vege: null,
      // ['LOAD', 'DATA', 'NETW', 'TABL', 'HIDD']
      tableStatus: 'HIDD'
    };

    this.options = {
      sizePerPage: 5,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '25', value: 25 }
      ]
    };
  }

  componentDidMount() {
    this.getTelefonEnum();
  }

  componentDidUpdate(prevProps) {
  }

  hasRoleKarb = () => {
    return this.props.globals.hasRole(['IDOPONT'], true);
  }

  getTelefonEnum = () => {
    Service.listTelefonEnum((err, res) => {
      if (!err) {
        this.setState({
          orszagOptions: res[0][0]
        });
      }
    });
  }

  updateFilters = () => {
    this.updateTeremFilter();
    Service.listDolgozo(true, (err, res) => {
      if (!err) {
        let dolgozoOptions = [];
        for (const dolgozo of res[0]) {
          let option = <option value={dolgozo.id}>{dolgozo.nev}</option>;
          Utility.insertByOrder(dolgozoOptions, option);
        }
        this.setState({ dolgozoOptions });
      }
    });
  }

  updateTeremFilter = () => {
    Service.listTerem((err, res) => {
      if (!err) {
        let teremOptions = [];
        for (let terem of res[0]) {
          let option = <option value={terem.id}>{terem.nev + ' (' + terem.azonosito + ')'}</option>
          Utility.insertByOrder(teremOptions, option);
        }
        this.setState({ teremOptions });
      }
    });
  }

  updateTable = () => {
    this.updateFilters();
    if (!this.state.kezdet) {
      this.props.globals.addError("A kezdeti idő választása kötelező!");
    } else {
      this.setState({ tableStatus: 'LOAD' }, () => {
        Service.listFoglalas(this.state.kezdet, this.state.vege, (err, res) => {
          if (!err) {
            let status = res[0].length == 0 ? 'DATA' : 'TABL';
            this.setState({ foglalasok: res[0], foglalasSelected: [], tableStatus: status });
          } else {
            this.setState({ tableStatus: 'NETW' });
          }
        });
      });
    }
  }

  toggleFoglalas = (edit) => {
    this.setState((prevState) => { return ({ modalFoglalas: !prevState.modalFoglalas }) });
    if (!edit)
      this.setState({ partnerobj: {} });
  }

  toggleFoglalasDelete = () => {
    this.setState((prevState) => { return ({ modalFoglalasDelete: !prevState.modalFoglalasDelete }) });
  }

  toggleFoglalasListConfirm = () => {
    this.setState((prevState) => { return ({ modalFoglalasListConfirm: !prevState.modalFoglalasListConfirm }) });
  }

  toggleFoglalasListDelete = () => {
    this.setState((prevState) => { return ({ modalFoglalasListDelete: !prevState.modalFoglalasListDelete }) });
  }

  togglePartner = () => {
    this.setState((prevState) => { return ({ modalPartner: !prevState.modalPartner }) });
  }

  handleForgalomSetState = (obj, callback) => {
    let obj2 = {};
    if (obj.hasOwnProperty('email'))
      obj2.email = obj.email;
    this.setState(obj2, callback);
  }

  handleFoglalasDeleteClick = (row) => {
    this._foglalasid = row.id;
    this.toggleFoglalasDelete();
  }

  handleFoglalasEditClick = (row) => {
    let foglalasid = row.id;
    Service.getFoglalas(foglalasid, (err, res) => {
      if (!err) {
        let obj = res[0];
        let szolgaltatasOptions = [];
        for (let szolgaltatas of obj.szolgaltatasok) {
          szolgaltatasOptions.push(<option value={szolgaltatas.id}>{szolgaltatas.nev}</option>);
        }
        obj.szolgaltatasOptions = szolgaltatasOptions;

        obj.date = new Date(obj.kezdet);
        obj.fogkezdet = new Date(obj.kezdet);

        let partnerobj = obj.partner;
        let telszam;
        if (partnerobj.telefon && partnerobj.telefon.length > 0) {
          telszam = partnerobj.telefon[0];
        }
        partnerobj.telefon = this.dataOrEmptyString(telszam);
        let szul = '';
        if (partnerobj.szulido) {
          // LocalDate JSON-ben tömb lesz, ezért van így formázva
          for (const string of partnerobj.szulido) {
            szul += string + '. ';
          }
        }
        partnerobj.szulido = szul;

        this.setState({ obj, partnerobj, insert: false });
        this.toggleFoglalas(true);
      }
    });
  }

  handlePartnerModalClick = () => {
    Service.getPartnerParameters((err, res) => {
      if (!err) {
        let partnerobj = this.state.partnerobj;
        partnerobj.pcsid = res[0].pcsoportid;
        partnerobj.jogAlapId = res[0].gdprjogalapid;
        this.setState({ partnerobj });
        let teremid = this.state.obj.teremid;
        Service.getTeremByIds([teremid], (err, res) => {
          if (!err) {
            let helyszinid = res[0][teremid].helyszinId;
            Service.getHelyszinByIds([helyszinid], (err, res) => {
              if (!err) {
                let partnerobj = this.state.partnerobj;
                partnerobj.cegadatId = res[0][helyszinid].cegadatId;
              }
            });
          }
        });
      }
    });
    Service.initPartnerCsop((err, res) => {
      if (!err) {
        let partnercsoportOptions = res[0].map(e => (
          <option key={e.id} value={e.id}>
            {e.nev}
          </option>
        ));
        this.setState({ partnercsoportOptions });
      }
    });
    this.togglePartner();
  }

  iconFormatter = (cell, row) => {
    return (
      <div>
        {
          this.hasRoleKarb()
            ? (
              <div>
                <Button className="icon-pencil table-action-icon" id={'action-view-' + cell + 'modositas'} onClick={() => this.handleFoglalasEditClick(row)} />
                <Button className="icon-trash table-action-icon" id={'action-view-' + cell + 'torles'} onClick={() => this.handleFoglalasDeleteClick(row)} />
              </div>
            )
            : <div />
        }
        <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + cell + 'modositas'} delay={0}>Módosítás</UncontrolledTooltip>
        <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + cell + 'torles'} delay={0}>Törlés</UncontrolledTooltip>
      </div>
    );
  }

  dataOrEmptyString = (string) => {
    if (string)
      return string;
    return '';
  }

  editFoglalas = (event, foglalasObj) => {
    let kezdet = new Date();
    const {
      date,
      fogkezdet,
      id,
      partner,
      partnerid,
    } = this.state.obj;
    let pid;
    if (partnerid == null)
      pid = partner.id;
    else
      pid = partnerid;
    foglalasObj.id = id;
    foglalasObj.partnerid = pid;
    kezdet.setFullYear(date.getFullYear());
    kezdet.setMonth(date.getMonth());
    kezdet.setDate(date.getDate());
    kezdet.setHours(fogkezdet.getHours());
    kezdet.setMinutes(fogkezdet.getMinutes());
    foglalasObj.kezdet = kezdet;
    foglalasObj.online = false;
    Service.editFoglalas(foglalasObj, this.state.email, (err) => {
      if (!err) {
        this.props.globals.addSuccess('Foglalás módosítva!');
        this.toggleFoglalas();
        this.updateTable();
      }
    });
  }

  deleteFoglalas = (event, obj) => {
    Service.deleteFoglalas(this._foglalasid, obj.reason, (err) => {
      if (!err) {
        this.props.globals.addSuccess('Foglalás törölve!');
        this.toggleFoglalasDelete();
        this.updateTable();
      }
    });
  }

  addPartner = (event, obj) => {
    if (obj.tel)
      obj.telefon = obj.tel;
    obj = {
      ...this.state.partnerobj,
      ...obj,
      tipus: 'MAGANSZEMELY',
      szallitovevo: 'VEVO',
      partnercsoportId: obj.pcsid,
      telefon: obj.tel,
      telefontipus: 'MOBIL',
      orszaghivo: this.state.orszaghivo
    };
    Service.addPartnerBase(obj, (err, res) => {
      if (!err) {
        this.togglePartner();
        Service.getPartner(res[0].ptId, (err, res) => {
          if (!err) {
            let obj = this.state.obj;
            obj.partnerid = res[0].id;
            let partnerobj = this.state.partnerobj;
            let telefon = null;
            if (res[0].telefon && res[0].telefon.length > 0)
              telefon = res[0].telefon;
            partnerobj = {
              ...partnerobj,
              szulido: res[0].szulido,
              email: res[0].email,
              nev: res[0].nev,
              telefon: this.dataOrEmptyString(telefon),
            };
            this.setState({ obj, partnerobj });
          }
        });
      }
    });
  }

  handlePartnerChange = (selectObj) => {
    let obj = this.state.obj;
    if (!selectObj) {
      obj.partnerid = null;
      let partnerobj = { szulido: '', email: '', nev: '', telefon: '' };
      this.setState({ obj, partnerobj });
    } else {
      obj.partnerid = selectObj.id;
      let telefon = null;
      if (selectObj.telefon && selectObj.telefon.length > 0)
        telefon = selectObj.telefon[0];
      let partnerobj = this.state.partnerobj;
      partnerobj = {
        ...partnerobj,
        szulido: selectObj.szulido ? (new String(selectObj.szulido).replace(/,/g, '.')) : '',
        email: this.dataOrEmptyString(selectObj.email),
        nev: this.dataOrEmptyString(selectObj.nev),
        telefon: this.dataOrEmptyString(telefon)
      };
      this.setState({ obj, partnerobj });
    }
  }

  handleDateInputChange = (name, date) => {
    this.setState({ obj: { ...this.state.obj, [name]: new Date(date) } });
  }

  handleFilterDateInputChange = (name, date) => {
    this.setState({ [name]: new Date(date) });
  }

  handlePartnerDateInputChange = (date) => {
    let partnerobj = this.state.partnerobj;
    partnerobj.szuletesnap = date;
    this.setState({ partnerobj });
  }

  handleTimeChange = (name, date) => {
    if (date) {
      // let minutes = date.getMinutes();
      // let deviation = minutes % 5;
      // if (deviation) {
      //   this.props.globals.addWarning("Az időpont perce csak öttel osztható szám lehet!");
      //   let correction = deviation <= 2 ? deviation : -(5 - deviation);
      //   date.setMinutes(minutes - correction);
      // }
      this.setState({ obj: { ...this.state.obj, [name]: new Date(date) } });
    } else {
      this.setState({ obj: { ...this.state.obj, [name]: null } });
    }
  }

  setOrszaghivo = (value) => {
    this.state.orszagOptions.forEach((item) => {
      if (item.num === value) {
        this.setState({ orszaghivo: item.name.toUpperCase() });
      }
    });
  }

  searchPartner = (input, callback) => {
    if (input.length !== 0) {
      Service.getPartnerList(input, (err, res) => {
        if (!err) {
          let newArray = [];
          res[0].forEach((item) => { newArray.push(item); });
          callback(newArray);
        }
      });
    }
  }

  onRowSelect = (row, isSelect) => {
    if (isSelect) {
      this.setState({ foglalasSelected: [...this.state.foglalasSelected, row.id] });
    } else {
      this.setState({ foglalasSelected: this.state.foglalasSelected.filter(x => x !== row.id) });
    }
  }

  onRowSelectAll = (isSelect, rows) => {
    const ids = rows.map(r => r.id);
    if (isSelect) {
      this.setState({ foglalasSelected: ids });
    } else {
      this.setState({ foglalasSelected: [] });
    }
  }

  confirmList = () => {
    Service.confirmList(this.state.foglalasSelected, (err) => {
      if (!err) {
        this.toggleFoglalasListConfirm();
        this.props.globals.addSuccess('Sikeres csoportos visszaigazolás!');
        this.updateTable();
      }
    });
  }

  deleteList = (event, obj) => {
    Service.deleteList(this.state.foglalasSelected, obj.reason, (err) => {
      if (!err) {
        this.toggleFoglalasListDelete();
        this.props.globals.addSuccess('Sikeres csoportos törlés!');
        this.updateTable();
      }
    });
  }

  renderTable = () => {
    const selectOptions = {
      true: 'Visszaigazolt',
      false: 'Visszaigazolásra vár',
    };

    const columns = [
      {
        dataField: 'partner.nev',
        text: 'Név',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true
      },
      {
        dataField: 'dolgozo.nev',
        text: 'Dolgozó',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true
      },
      {
        dataField: 'terem.nev',
        text: 'Terem',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true
      },
      {
        dataField: 'kezdet',
        text: 'Dátum',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        formatter: this.dateFormatter,
        sort: true
      },
      {
        dataField: 'kezdet',
        text: 'Óra',
        formatter: this.timeFormatter,
      },
      {
        dataField: 'visszaigazolt',
        text: 'Státusz',
        filter: selectFilter({
          options: selectOptions,
          placeholder: 'Összes',
        }),
        style: {
          textAlign: 'center',
          whiteSpace: 'pre-line'
        },
        formatter: this.statusFormatter,
        sort: true
      }
    ];

    const columns2 = [
      ...columns,
      {
        dataField: 'id',
        text: 'Műveletek',
        formatter: this.iconFormatter
      }
    ];

    const {
      foglalasSelected
    } = this.state;

    return (
      <div>
        <BootstrapTable2
          bootstrap4
          keyField="id"
          data={this.state.foglalasok}
          columns={this.hasRoleKarb() ? columns2 : columns}
          filter={filterFactory()}
          pagination={paginationFactory(Lib.bootstraptableProps)}
          selectRow={{
            mode: 'checkbox',
            onSelect: this.onRowSelect,
            onSelectAll: this.onRowSelectAll
          }}
        />
        <div className="row" style={{ marginLeft: 0 }}>
          <Button color='primary' style={{ marginRight: '15px' }} onClick={this.toggleFoglalasListConfirm} disabled={foglalasSelected.length == 0}>Csoportos visszaigazolás</Button>
          <Button color='danger' onClick={this.toggleFoglalasListDelete} disabled={foglalasSelected.length == 0}>Csoportos elutasítás</Button>
        </div>
      </div>
    );
  }

  dateFormatter = (cell) => {
    return new Date(cell).toLocaleDateString();
  }

  timeFormatter = (cell) => {
    let date = new Date(cell);
    return date.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' });
  }

  statusFormatter = (cell) => {
    switch (cell) {
      case true:
        return <span className="badge badge-success">Visszaigazolt</span>;
      case false:
        return <span className="badge badge-default">Visszaigazolásra vár</span>;
      default:
        return <span className="badge badge-default">Ismeretlen</span>;
    }
  }

  renderMain = () => {
    return <div>
      <RFForm onSubmit={this.updateTable}>
        <div className="row">
          <div className="col-md-3">
            <DatePicker
              label="Intervallum kezdete: *"
              id='kezdet'
              name='kezdet'
              onChange={(d) => { this.handleFilterDateInputChange('kezdet', d) }}
              value={this.state.kezdet}
            />
          </div>
          <div className="col-md-3">
            <DatePicker
              label="Intervallum vége:"
              id='vege'
              name='vege'
              onChange={(d) => { this.handleFilterDateInputChange('vege', d) }}
              value={this.state.vege}
            />
          </div>
          <div className="col-md-2" style={{ marginTop: 29 }}>
            {/* <ProgressButton color="primary" id="search" loading={false} onClick={this.updateTable} >Lekérdezés</ProgressButton> */}
            <ProgressButton color="primary" type='submit' id="search" loading={false}>Lekérdezés</ProgressButton>
          </div>
        </div>
      </RFForm>
      {this.renderState()}
    </div>
  }

  renderState = () => {
    switch (this.state.tableStatus) {
      case 'NETW':
        return <NetworkEmptyState hasImage submitClick={this.updateTable} />;
      case 'DATA':
        return <DataEmptyState hasImage subtitle='Rögzítsen új foglalást' />;
      case 'TABL':
        return this.renderTable();
      case 'LOAD':
        return <Loader />;
      case 'HIDD':
        return <div />
    }
  }

  render() {
    const {
      modalFoglalas,
      modalFoglalasDelete,
      modalFoglalasListConfirm,
      modalFoglalasListDelete,
      modalPartner,
      partnercsoportOptions,
    } = this.state;
    return (
      <div>
        {this.renderMain()}
        <Modal isOpen={modalFoglalasListDelete} toggle={this.toggleFoglalasListDelete} className={this.props.className} backdrop="static">
          <RFForm
            modal
            onSubmit={this.deleteList}
            title="Foglalások elutasítása"
            footer={
              <>
                <Button color="primary">OK</Button>
                <Button type="button" color="secondary" onClick={this.toggleFoglalasListDelete}>Mégsem</Button>
              </>
            }
          >
            <RFField
              label="Elutasítás oka: *"
              style={{ height: '120px' }}
              type='textarea'
              name='reason'
              required
            />
          </RFForm>
        </Modal>
        <Modal isOpen={modalFoglalasListConfirm} toggle={this.toggleFoglalasListConfirm} className={this.props.className} backdrop="static">
          <RFForm
            modal
            onSubmit={this.confirmList}
            title="Foglalások visszaigazolása"
            footer={
              <>
                <Button color="primary">OK</Button>
                <Button type="button" color="secondary" onClick={this.toggleFoglalasListConfirm}>Mégsem</Button>
              </>
            }
          >
            Biztosan vissza szeretnéd igazolni a kijelölt foglalásokat?
          </RFForm>
        </Modal>
        <ModalFoglalas
          className={this.props.className}
          handleDateInputChange={this.handleDateInputChange}
          handlePartnerChange={this.handlePartnerChange}
          handlePartnerModalClick={this.handlePartnerModalClick}
          handleTimeChange={this.handleTimeChange}
          isOpen={modalFoglalas}
          isOpenDelete={modalFoglalasDelete}
          toggleDelete={this.toggleFoglalasDelete}
          editFoglalas={this.editFoglalas}
          deleteFoglalas={this.deleteFoglalas}
          searchPartner={this.searchPartner}
          state={this.state}
          setState={this.handleForgalomSetState}
          toggle={this.toggleFoglalas}
        />
        <ModalPartner
          className={this.props.className}
          handlePartnerDateInputChange={this.handlePartnerDateInputChange}
          isOpen={modalPartner}
          onOKClick={this.addPartner}
          partnercsoportOptions={partnercsoportOptions}
          setOrszaghivo={this.setOrszaghivo}
          state={this.state}
          toggle={this.togglePartner}
        />
      </div>
    );
  }
}

export default Tablazat;
